import React from "react";

export default function SiteMap(props) {
  return (
    <div className="tabs-container container">
      <div className="contactUs-container pl-0 row">
        <div className="contactUs-subContainer">
          <div className="terms-of-use-head p-4">
            <h1 className="p-2 dib terms-page-heading">SITE MAP</h1>
          </div>

          <div className="container-body p-4 mt-2">
            <div className="block-elm px-2 mb-3">
              <p>
                Use the links below to navigate through the portal.
              </p>

              <ul className="p-0 ml-3">
                <li className="pb-2"><a href="/home">Home</a></li>
                <li className="pb-2"><a href={process.env.REACT_APP_ADMIN}>Admin Login</a></li>
                <li className="pb-2"><a href="/registration">Member Registration</a></li>
                <li className="pb-2"><a href="/doc" onClick={() => { localStorage.setItem("IoxDocName", "Education_Materials"); }} rel="noopener noreferrer">Review education_Materials here<span className="visuallyhidden"> opens in a new tab</span></a></li>
                <li className="pb-2"><a href="/appRegistration">Register your app here</a></li>
                <li className="pb-2"><a href="/doc" onClick={() => { localStorage.setItem("IoxDocName", "API"); }} rel="noopener noreferrer">API Documentation<span className="visuallyhidden"> opens in a new tab</span></a></li>
                <li className="pb-2"><a href={process.env.REACT_APP_MEMBER}>Member Login</a></li>
                <li className="pb-2"><a href="/PrivacyPolicy">Privacy Policy</a></li>
                <li className="pb-2"><a href="/termsOfUse">Terms of Use</a></li>
                <li className="pb-2"><a href="/BrowserRequirements">Browser Requirements</a></li>
                <li className="pb-2"><a href="/AccessibilityCompliance">Accessibility Compliance</a></li>
                <li className="pb-2"><a href={process.env.REACT_APP_MEMBER_FORGETUSERNAME}>Member - Forgot Username?</a></li>
                <li className="pb-2"><a href={process.env.REACT_APP_MEMBER_FORGETPASSWORD}>Member - Forgot Password?</a></li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}